module.exports = __webpack_public_path__ + "e280cf48a6e0e7e1558c8dbc55ea4b07.png";